/**
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @author Karlis Ruza <info@scandiweb.com
 * @link https://github.com/scandipwa/base-theme
 */

export const EN_POSTFIX_LENGTH = 3;
export const DEFAULT_COUNTRY_UAE = 'AE';
